import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "122",
  height: "36",
  viewBox: "0 0 122 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]
const _hoisted_14 = ["fill"]
const _hoisted_15 = ["fill"]
const _hoisted_16 = ["fill"]
const _hoisted_17 = ["fill"]
const _hoisted_18 = ["fill"]
const _hoisted_19 = ["fill"]
const _hoisted_20 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, { to: "/" }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _createElementVNode("path", {
          d: "M57.6182 4.10303H61.7381C65.5506 4.10303 67.7643 6.31674 67.7643 9.39134C67.7643 12.4659 65.5506 14.7411 61.6766 14.7411H57.6182V4.10303ZM61.7381 12.1585C63.5214 12.1585 64.6897 11.1746 64.6897 9.45283C64.6897 7.73105 63.5214 6.74718 61.7381 6.74718H60.5083V12.1585H61.7381Z",
          fill: _ctx.color
        }, null, 8, _hoisted_2),
        _createElementVNode("path", {
          d: "M69.2402 4.10303H74.2825C75.9428 4.10303 77.0497 4.53347 77.7876 5.27138C78.4025 5.88629 78.71 6.68569 78.71 7.73105C78.71 9.39134 77.8491 10.4367 76.4962 10.9901L79.0174 14.6796H75.5739L73.4217 11.4206H72.1303V14.6796H69.1787V4.10303H69.2402ZM74.1596 9.26835C75.1434 9.26835 75.7583 8.77641 75.7583 7.97702C75.7583 7.11613 75.1434 6.68569 74.1596 6.68569H72.1918V9.26835H74.1596Z",
          fill: _ctx.color
        }, null, 8, _hoisted_3),
        _createElementVNode("path", {
          d: "M80.2471 4.10303H88.8559V6.6242H83.1987V8.22299H88.3025V10.5597H83.1987V12.2815H88.9174V14.8026H80.2471V4.10303Z",
          fill: _ctx.color
        }, null, 8, _hoisted_4),
        _createElementVNode("path", {
          d: "M90.3936 4.10303H93.3452V8.1H97.1577V4.10303H100.109V14.8026H97.1577V10.7442H93.3452V14.8026H90.3936V4.10303Z",
          fill: _ctx.color
        }, null, 8, _hoisted_5),
        _createElementVNode("path", {
          d: "M102.016 4.10303H110.624V6.6242H104.967V8.22299H110.071V10.5597H104.967V12.2815H110.686V14.8026H102.016V4.10303Z",
          fill: _ctx.color
        }, null, 8, _hoisted_6),
        _createElementVNode("path", {
          d: "M112.223 4.10303H117.265C118.925 4.10303 120.032 4.53347 120.77 5.27138C121.385 5.88629 121.692 6.68569 121.692 7.73105C121.692 9.39134 120.832 10.4367 119.479 10.9901L122 14.6796H118.556L116.404 11.4206H115.113V14.6796H112.223V4.10303ZM117.142 9.26835C118.126 9.26835 118.741 8.77641 118.741 7.97702C118.741 7.11613 118.126 6.68569 117.142 6.68569H115.174V9.26835H117.142Z",
          fill: _ctx.color
        }, null, 8, _hoisted_7),
        _createElementVNode("path", {
          d: "M57.6797 26.3629C57.6797 23.4113 59.8934 20.8286 63.1525 20.8286C66.4115 20.8286 68.5638 23.3498 68.5638 26.3014C68.5638 29.253 66.3501 31.8357 63.091 31.8357C59.8319 31.8357 57.6797 29.3145 57.6797 26.3629ZM67.3339 26.3629C67.3339 23.9032 65.5507 21.9355 63.1525 21.9355C60.6928 21.9355 58.971 23.9032 58.971 26.3014C58.971 28.6996 60.7543 30.7288 63.1525 30.7288C65.5507 30.7288 67.3339 28.7611 67.3339 26.3629Z",
          fill: _ctx.color
        }, null, 8, _hoisted_8),
        _createElementVNode("path", {
          d: "M71.1464 20.9517H72.2533L78.9559 29.499V20.9517H80.1243V31.6513H79.1404L72.2533 22.9194V31.6513H71.085V20.9517H71.1464Z",
          fill: _ctx.color
        }, null, 8, _hoisted_9),
        _createElementVNode("path", {
          d: "M83.1987 20.9517H84.4286V30.4829H90.4548V31.5898H83.2602V20.9517H83.1987Z",
          fill: _ctx.color
        }, null, 8, _hoisted_10),
        _createElementVNode("path", {
          d: "M92.73 20.9517H93.9598V31.6513H92.73V20.9517Z",
          fill: _ctx.color
        }, null, 8, _hoisted_11),
        _createElementVNode("path", {
          d: "M97.0957 20.9517H98.2025L104.905 29.499V20.9517H106.073V31.6513H105.09L98.2025 22.9194V31.6513H97.0342V20.9517H97.0957Z",
          fill: _ctx.color
        }, null, 8, _hoisted_12),
        _createElementVNode("path", {
          d: "M109.148 20.9517H116.834V22.0585H110.316V25.6865H116.158V26.7934H110.316V30.5444H116.896V31.6513H109.148V20.9517Z",
          fill: _ctx.color
        }, null, 8, _hoisted_13),
        _createElementVNode("path", {
          d: "M36.0958 21.0748L37.8175 16.2784L42.4294 17.9387L45.8115 8.6534L33.6361 4.22598L30.254 13.5113L34.8659 15.1715L30.254 27.9619C30.254 24.3338 27.6714 21.2592 24.2278 20.4599V14.0647H25.5192V16.2169H28.5938V0.229004H25.5192V2.38122H24.2278V0.229004H21.0917V2.38122H19.8004V0.229004H16.6643V16.2169H19.8004V14.0647H21.0917V20.3984C17.7097 21.0133 15.127 23.9034 14.881 27.3469L11.3145 17.5082C13.2823 16.0324 14.1431 13.4498 13.2823 11.1131L10.5151 3.54957L0 7.36207L2.76714 14.9256C3.62802 17.2623 5.96472 18.7996 8.4244 18.6151L13.5897 32.8197H2.58266V33.8036H17.4022C18.755 35.0334 20.5383 35.7713 22.506 35.7713C24.4738 35.7713 26.2571 35.0334 27.6099 33.8036H42.7369V32.8197H31.8528C33.2056 28.9457 34.8044 24.5798 36.0958 21.0748ZM41.876 16.7088L40.6462 16.2784L43.3518 8.83788L44.5817 9.26832L41.876 16.7088ZM42.0605 9.63727L35.7883 7.36207L36.2188 6.19372L42.4909 8.46893L42.0605 9.63727ZM35.4808 8.28445L41.753 10.5596L41.3841 11.6665L35.1119 9.3913L35.4808 8.28445ZM34.7429 10.3137L41.0151 12.5889L40.7077 13.5113L34.4355 11.2361L34.7429 10.3137ZM34.251 5.45582L35.3579 5.82477L32.6522 13.2653L31.5454 12.8349L34.251 5.45582ZM33.5131 13.6957L34.0665 12.1584L40.3387 14.4336L39.7853 16.0324L37.2641 15.1101L35.1734 20.8288C33.8821 24.4568 32.2218 29.0072 30.8075 32.8812H29.5776L36.1573 14.7411L33.5131 13.6957ZM22.5675 34.7875L28.4093 24.7028C28.9627 25.6867 29.3317 26.7935 29.3317 28.0234C29.3317 31.7129 26.3185 34.726 22.5675 34.7875ZM18.0171 25.0103H27.1179L22.5675 32.8812L18.0171 25.0103ZM22.0756 20.2754V13.1423H18.878V15.2945H17.7097V1.21287H18.878V3.36509H22.0756V1.21287H23.244V3.36509H26.4415V1.21287H27.6099V15.2945H26.4415V13.1423H23.244V20.3369H22.5675L22.0756 20.2754ZM22.5675 21.2592C24.8427 21.2592 26.749 22.3661 27.9788 24.0264H17.1563C18.3861 22.3661 20.3538 21.2592 22.5675 21.2592ZM16.7258 24.7028L22.5675 34.7875C18.878 34.7875 15.8034 31.7744 15.8034 28.0234C15.8034 26.7935 16.1724 25.6867 16.7258 24.7028ZM9.03932 17.5697L8.67036 17.6312C6.51814 17.9387 4.42742 16.6474 3.68952 14.6181L1.29133 7.9155L9.96169 4.77941L12.3599 11.482C13.0978 13.5113 12.2984 15.848 10.4536 16.9548L10.1462 17.1393L15.8649 32.7582H14.6351L9.03932 17.5697Z",
          fill: _ctx.color
        }, null, 8, _hoisted_14),
        _createElementVNode("path", {
          d: "M18.8784 7.66929H22.076V4.5332H18.8784V7.66929ZM19.8623 5.51707H21.1536V6.68542H19.8623V5.51707Z",
          fill: _ctx.color
        }, null, 8, _hoisted_15),
        _createElementVNode("path", {
          d: "M18.8784 11.9125H22.076V8.83789H18.8784V11.9125ZM19.8623 9.76027H21.1536V10.9286H19.8623V9.76027Z",
          fill: _ctx.color
        }, null, 8, _hoisted_16),
        _createElementVNode("path", {
          d: "M26.4412 4.5332H23.2437V7.66929H26.4412V4.5332ZM25.5189 6.68542H24.2275V5.51707H25.5189V6.68542Z",
          fill: _ctx.color
        }, null, 8, _hoisted_17),
        _createElementVNode("path", {
          d: "M26.4412 8.83789H23.2437V11.9125H26.4412V8.83789ZM25.5189 10.9901H24.2275V9.82176H25.5189V10.9901Z",
          fill: _ctx.color
        }, null, 8, _hoisted_18),
        _createElementVNode("path", {
          d: "M11.3759 12.9578L9.22365 6.87012L8.30127 7.17758L10.515 13.2653L11.3759 12.9578Z",
          fill: _ctx.color
        }, null, 8, _hoisted_19),
        _createElementVNode("path", {
          d: "M6.3335 7.91537L8.97765 15.4174L9.90003 15.1099L7.19438 7.60791L6.3335 7.91537Z",
          fill: _ctx.color
        }, null, 8, _hoisted_20)
      ]))
    ]),
    _: 1
  }))
}